import { createChart } from "bi-sdk";

export const setPieTotal = function (chartData, chartId, unit, color, total) {
  let chart = createChart(
    {
      legend: {
        // right: 0,
        bottom: 0,
        left: "center",
        icon: "circle",
        itemWidth: 8,
        itemHeight: 8,
        itemGap: 24,
        textStyle: {
          color: "#86909C",
          fontSize: 12
        }
      },
      title: {
        text: "{a|" + unit + "}",
        textStyle: {
          rich: {
            a: {
              color: "#778493",
              fontSize: 12,
              padding: [-25, 0, 0]
            }
          }
        },
        subtext: "{a|" + total + "}",
        subtextStyle: {
          rich: {
            a: {
              color: "#2E384D",
              fontSize: 24,
              fontFamily: "Roboto-bold, Roboto",
              // fontWeight: 500,
              padding: [-20, 0, 0]
            }
          }
        },
        itemGap: -10,
        left: "center",
        top: "center"
      },
      series: [
        {
          type: "pie",
          radius: ["38%", "65%"],
          color: color,
          label: {
            show: true,
            formatter: "{b|{b}: {@[1]}吨标煤}{d|{d}%}",
            rich: {
              b: {
                color: "#4E5969",
                fontSize: 12,
                lineHeight: 33,
                padding: [0, 0, 20, 0]
              },
              d: {
                color: "#1D2129",
                fontSize: 14,
                fontWeight: 550,
                padding: [0, 0, 18, 6]
              }
            }
          },
          labelLine: {
            length: 20,
            lineStyle: {
              color: "#E5E6EB"
            }
          },
          labelLayout: function (params) {
            const isLeft = params.labelRect.x < chart.$chart.getWidth() / 2;
            const points = params.labelLinePoints;
            points[2][0] = isLeft
              ? params.labelRect.x
              : params.labelRect.x + params.labelRect.width;
            return {
              labelLinePoints: points
            };
          },
          data: chartData.source.count.map((item, i) => {
            return {
              name: chartData.source.product[i],
              value: item,
              itemStyle: {
                color: color[i],
                emphasis: {
                  color: color[i] == "#E5E6EB" ? "#F2F3F5" : color[i]
                }
              }
            };
          })
        }
      ],
      dataSet: chartData
    },
    { extend: ["title", "legend"] } // extend内容会使用默认配置
  );
  // chart.dataSet(chartData);
  chart.amount(chartId); // 等同init
  return chart;
};

export const setPieCost = function (chartData, color, total, chartId) {
  let chart = createChart(
    {
      legend: {
        // right: 0,
        show: false
      },
      title: {
        text: "总消费金额",
        textStyle: {
          color: "#86909C",
          fontFamily: "DIN-Medium, DIN",
          fontSize: 12
        },
        subtext: "{a|¥}{b|" + total + "}",
        subtextStyle: {
          rich: {
            a: {
              color: "#1D2129",
              fontSize: 14,
              fontWeight: 500,
              padding: [-52, 0, 0]
            },
            b: {
              color: "#1D2129",
              fontSize: 24,
              fontWeight: 500,
              padding: [-52, 0, 0]
            }
          }
        },
        itemGap: -10,
        left: "center",
        top: "50%"
      },
      series: [
        {
          type: "pie",
          radius: ["102", "78"],
          center: ["center", "center"],
          color: color,
          label: {
            show: true,
            formatter: "{b|{b}}",
            rich: {
              b: {
                color: "#1D2129",
                fontSize: 14,
                fontWeight: 400
              }
            }
          },
          labelLine: {
            length: 40
          },
          emphasis: {
            disabled: true
          },
          data: chartData.source.count.map((item, i) => {
            return {
              name: chartData.source.product[i],
              value: item,
              itemStyle: {
                color: color[i],
                emphasis: {
                  color: color[i] == "#E5E6EB" ? "#F2F3F5" : color[i]
                }
              }
            };
          })
        }
      ],
      dataSet: chartData
    },
    { extend: ["title", "legend"] } // extend内容会使用默认配置
  );
  // chart.dataSet(chartData);
  chart.amount(chartId); // 等同init
  return chart;
};
